module.exports = __webpack_public_path__ + "img/south-sask-bus-lines.c615a39e.webp";